export const cash_types = [
  'Cheque',
  'Credit Transfer',
  'Direct Debit',
  'Standing Order',
  'Cash',
  'Bankers Draft',
  'CHAPS',
  'BACS',
  'Transfer',
  'Refer to Drawer',
  'Represented',
  'Written Back',
  'DirectToClient',
  'Allocation',
  'Faster Payments',
  ''
];
